import { render, staticRenderFns } from "./EditGlobalAddressDialog.vue?vue&type=template&id=137bffdc&scoped=true&"
import script from "./EditGlobalAddressDialog.vue?vue&type=script&lang=js&"
export * from "./EditGlobalAddressDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditGlobalAddressDialog.vue?vue&type=style&index=0&id=137bffdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137bffdc",
  null
  
)

/* custom blocks */
import block0 from "./EditGlobalAddressDialog.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports